module.exports = __webpack_public_path__ + "static/media/Lady Liberty.1e3ad302.jpg";